<template>
  <div>

<!--    <div v-if="requests" class="loading_page">-->
<!--      <orbit-spinner :animation-duration="1000" :size="100" :color="'#0e96b1'"/>-->
<!--    </div>-->

    <b-tabs vertical content-class="col-12 col-md-9 mt-1 mt-md-0" pills
        nav-wrapper-class="col-md-3 col-12 border rounded p-1" nav-class="nav-left">

      <!-- users tab -->
      <b-tab>
        <!-- title -->
        <template #title>
          <feather-icon icon="KeyIcon" size="18" class="mr-50"/>
          <span class="font-weight-bold">{{ $t('Roles')}}</span>
        </template>
        <roles-tab :user="user"></roles-tab>
      </b-tab>


      <!-- users tab -->
      <b-tab lazy>
        <!-- title -->
        <template #title>
          <feather-icon icon="UsersIcon" size="18" class="mr-50"/>
          <span class="font-weight-bold">{{ $t('Users')}}</span>
        </template>
        <users-tab :user="user"></users-tab>
      </b-tab>


      <!-- devices tab -->
      <b-tab lazy>
        <!-- title -->
        <template #title>
          <feather-icon icon="TruckIcon" size="18" class="mr-50"/>
          <span class="font-weight-bold">{{ $t('Devices')}}</span>
        </template>
        <devices-tab :user="user"></devices-tab>
      </b-tab>


      <!-- geofence tab -->
      <b-tab lazy>
        <!-- title -->
        <template #title>
          <feather-icon icon="GlobeIcon" size="18" class="mr-50"/>
          <span class="font-weight-bold">{{ $t('Geofence')}}</span>
        </template>
        <geofence-tab :user="user"></geofence-tab>
      </b-tab>


      <!-- container tab -->
      <b-tab lazy>
        <!-- title -->
        <template #title>
          <feather-icon icon="TrashIcon" size="18" class="mr-50"/>
          <span class="font-weight-bold">{{ $t('Containers')}}</span>
        </template>
        <containers-tab :user="user"></containers-tab>
      </b-tab>


      <!-- group tab -->
      <b-tab lazy>
        <!-- title -->
        <template #title>
          <feather-icon icon="GridIcon" size="18" class="mr-50"/>
          <span class="font-weight-bold">{{ $t('Groups')}}</span>
        </template>
        <groups-tab :user="user"></groups-tab>
      </b-tab>



      <!-- contracts tab -->
      <b-tab lazy>
        <template #title>
          <feather-icon icon="FileIcon" size="18" class="mr-50"/>
          <span class="font-weight-bold">{{ $t('Contracts')}}</span>
        </template>
        <contracts-tab :user="user"></contracts-tab>
      </b-tab>


      <!-- plans tab -->
      <b-tab lazy>
        <template #title>
          <feather-icon icon="FileIcon" size="18" class="mr-50"/>
          <span class="font-weight-bold">{{ $t('Plans')}}</span>
        </template>
        <plans-tab :user="user"></plans-tab>
      </b-tab>

      <!-- geofence plans tab -->
      <b-tab lazy>
        <template #title>
          <feather-icon icon="FileIcon" size="18" class="mr-50"/>
          <span class="font-weight-bold">{{ $t('Geofence Plan')}}</span>
        </template>
        <g-plans-tab :user="user"></g-plans-tab>
      </b-tab>





      <b-tab lazy>
        <template #title>
          <feather-icon icon="ArchiveIcon" size="18" class="mr-50"/>
          <span class="font-weight-bold">{{ $t('Reports')}}</span>
        </template>
        <report-tab :user="user"></report-tab>
      </b-tab>

      <b-tab lazy>
        <template #title>
          <feather-icon icon="CodesandboxIcon" size="18" class="mr-50"/>
          <span class="font-weight-bold">{{ $t('Dashborad Widget')}}</span>
        </template>
        <widget-tab :user="user"></widget-tab>
      </b-tab>


      <!--      &lt;!&ndash; drivers tab &ndash;&gt;-->
<!--      <b-tab lazy>-->
<!--        &lt;!&ndash; title &ndash;&gt;-->
<!--        <template #title>-->
<!--          <feather-icon icon="UserIcon" size="18" class="mr-50"/>-->
<!--          <span class="font-weight-bold">{{ $t('Drivers Permission')}}</span>-->
<!--        </template>-->
<!--        <drivers-tab :user="user"></drivers-tab>-->
<!--      </b-tab>-->


<!--      &lt;!&ndash; calendars tab &ndash;&gt;-->
<!--      <b-tab lazy>-->
<!--        &lt;!&ndash; title &ndash;&gt;-->
<!--        <template #title>-->
<!--          <feather-icon icon="CalendarIcon" size="18" class="mr-50"/>-->
<!--          <span class="font-weight-bold">{{ $t('Calendars Permission')}}</span>-->
<!--        </template>-->
<!--        <calendars-tab :user="user" @requestIncrement="requestIncrement"-->
<!--                     @requestDecrement="requestDecrement">-->
<!--        </calendars-tab>-->
<!--      </b-tab>-->

    </b-tabs>
  </div>
</template>

<script>
import { BButton, BTable, BTabs, BTab } from 'bootstrap-vue'
import MenuTab from '@/views/modules/user/users-edit/permissions/MenusTab'
import DevicesTab from '@/views/modules/user/users-edit/permissions/DevicesTab'
import GeofenceTab from '@/views/modules/user/users-edit/permissions/GeofenceTab'
import GroupsTab from '@/views/modules/user/users-edit/permissions/GroupsTab'
import DriversTab from '@/views/modules/user/users-edit/permissions/DriversTab'
import CalendarsTab from '@/views/modules/user/users-edit/permissions/CalendarsTab'
import UsersTab from '@/views/modules/user/users-edit/permissions/UsersTab'
import ContractsTab from "@/views/modules/user/users-edit/permissions/ContractsTab"
import RolesTab from "@/views/modules/user/users-edit/permissions/RolesTab"
import ContainersTab from '@/views/modules/user/users-edit/permissions/ContainersTab'
import PlansTab from '@/views/modules/user/users-edit/permissions/PlansTab'
import GPlansTab from '@/views/modules/user/users-edit/permissions/GPlansTab'
import ReportTab from '@/views/modules/user/users-edit/permissions/ReportTab'
import WidgetTab from '@/views/modules/user/users-edit/permissions/WidgetTab'
import { OrbitSpinner } from 'epic-spinners'

export default {
  props: ['user'],
  components: {
    BButton,CalendarsTab,UsersTab,RolesTab,ContainersTab,
    BTable, MenuTab,DevicesTab, GeofenceTab,DriversTab, GPlansTab,
    BTabs, BTab, OrbitSpinner, GroupsTab, ContractsTab, PlansTab,ReportTab,WidgetTab
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
